import styled from "styled-components";

export const GlobalProyectos = styled.div`
  margin-top: 200px;
  height: 600px;
  background: black;
`;
